import { render, staticRenderFns } from "./OrganismPageLoader.vue?vue&type=template&id=52384327&"
import script from "./OrganismPageLoader.vue?vue&type=script&lang=js&"
export * from "./OrganismPageLoader.vue?vue&type=script&lang=js&"
import style0 from "./OrganismPageLoader.vue?vue&type=style&index=0&id=52384327&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomCircleProgressLoader: require('/app/components/atoms/common/AtomCircleProgressLoader.vue').default,AtomsCommonAtomLogo: require('/app/components/atoms/common/AtomLogo.vue').default})
